<div class="coupon-container">
  <app-breadcrumb [title]="'Betslip' | transloco" navIcon="betslip"></app-breadcrumb>
  <app-coupon></app-coupon>
</div>
